import React from 'react'
import { Box, Image } from '@chakra-ui/react'
import { baseUrl } from '../../../config'

export default function MapLegend() {
  return (
    <Box
      position="absolute"
      bottom={{ base: '100px', md: '50px' }}
      right="5px"
      zIndex="1100"
    >
      <Image
        height={{ base: 300, md: 450 }}
        src={`${baseUrl}/images/TURBO_CR_FINAL.png`}
      ></Image>
    </Box>
  )
}
